import { toast } from 'react-toastify'

import { MessageType } from '@/shared/api'
import { ErrorDialogProps, useErrorDialogStore } from '@/shared/store'

const DEFAULT_MESSAGE =
  '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'

const isNetworkError = (error: unknown): error is TypeError => {
  return (
    error instanceof TypeError &&
    (error.message.includes('Failed to fetch') ||
      error.message.includes('NetworkError'))
  )
}

type NetworkErrorHandlerProps = {
  error: unknown
} & Partial<ErrorDialogProps>

export const useNetworkErrorHandler = () => {
  const { actions } = useErrorDialogStore()

  const handleNetworkError = ({
    error,
    onConfirm,
    title = '저장에 실패하였습니다',
    content = '네트워크 상태 확인 후 다시 시도해 주세요.',
    cancelText = '닫기',
    confirmText = '다시 시도하기',
    type = MessageType.CONFIRM,
    ...restProps
  }: NetworkErrorHandlerProps) => {
    const handleConfirm = () => {
      actions.close()

      onConfirm?.()
    }

    if (!isNetworkError(error)) {
      toast(DEFAULT_MESSAGE)

      return
    }

    actions.open({
      title,
      content,
      cancelText,
      confirmText,
      type,
      onConfirm: handleConfirm,
      ...restProps,
    })
  }

  return { handleNetworkError }
}
